import { render, staticRenderFns } from "./templete.vue?vue&type=template&id=4e8ed5ea&"
import script from "./templete.vue?vue&type=script&lang=js&"
export * from "./templete.vue?vue&type=script&lang=js&"
import style0 from "./templete.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports